/*
 * This is an example of how to nest functionality within the Hybrid module.
 * eg Usage
 *  BackOffice.Integration.DoStuff('something', 'something else');
 */

//  AccountingIntegration.aspx
var IntegrationDetails = (function(backOffice, $) {

    backOffice.Integration.IntegrationDetails = (function() {
		var scopeSelector = backOffice.options.scopeSelector;
		var integrationData, settingsData, isCurrentUserGod;

        //  enum used to determine state of tab data
        var dataValidState = Object.freeze({ 
            "Error": 0, 
            "Valid": 1, 
			"AllowRetry": 2,
			"Warning": 3,
			"ToDataValidState": function (value) {
				if (value == 3) {
					return dataValidState.Warning
                }
				else if (value) { // allows true or 1
                    return dataValidState.Valid;
                }
            
                return dataValidState.Error;
            }});
        
        var determineErrorOrRetry = function (xhrResponse) {
            //  this is the rule used by all integration user controls to determine if retry is permitted. It is called by each control
            return (xhrResponse && xhrResponse.status == 500) ? dataValidState.Error : dataValidState.AllowRetry;
        };

		var initialise = function(options) {
			options.isAllDataValid = false;
			options.allTabsReportedTheirStatus = false;
			$.extend(backOffice.options, options);
			integrationData = options.integrationData;
			settingsData = options.settingsData;
			isCurrentUserGod = options.isCurrentUserGod;
			setIntegrationEnabled(integrationData.is_enabled);
			setDisabledIntegrationByAdmin(integrationData.is_disabled_by_admin, isCurrentUserGod);
			cacheStatusSelection();
			events();
		},
			events = function() {
				$("#tbNotificationEmail", scopeSelector).on("change input", function() {
					var emailIsValid = BackOffice.IsEmailValid($(this));
					if (!emailIsValid) {
                        backOffice.options.isAllDataValid = dataValidState.Error;
						setIntegrationEnabled(emailIsValid);
					} else if ($("tr.validation-errors", scopeSelector)
                        .filter(function(index, element){
                            // do not need to check Email field itself
                            return $(element).data("tabname") !== "Email";
                        }).length == 0) {
                        backOffice.options.isAllDataValid = dataValidState.Valid;
					}

					updateTabStatusIndicators(
						"Email",
						emailIsValid ? dataValidState.Valid : dataValidState.Error,
						false,
						null,
						function() {
							handleAllDataIsValid(
								backOffice.options.isAllDataValid,
								backOffice.options.allTabsReportedTheirStatus
							);
						}
					);

					tabs.filter(function(tabInfo) {
						return tabInfo.configurationStatusName === "Email";
					})[0].isDataValid = emailIsValid;
				});

				$("#rbnEnabled, #rbnDisabled", scopeSelector).on("change", function() {
					var $rbnEnable = $("#rbnEnabled", scopeSelector);
					var $rbnDisable = $("#rbnDisabled", scopeSelector);
					var isIntegrationEnabled = $(this).attr("id") == "rbnEnabled";

					if (isIntegrationEnabled) {
						$rbnEnable.attr("checked", "checked");
						$rbnDisable.removeAttr("checked");
					} else {
						$rbnDisable.attr("checked", "checked");
						$rbnEnable.removeAttr("checked");
					}

					setIntegrationEnabled(isIntegrationEnabled);
					cacheStatusSelection();
				});

				$(".btn-unauth").on("click", function() {
					var $rbnEnable = $("#rbnEnabled", scopeSelector);
					integrationData.is_enabled = $rbnEnable.prop("checked");
					setIntegrationData(integrationData);
				});
			},
			updateTabStatusIndicators = function(
				tabName,
				validatedSuccessfully,
				clearText,
				errorType,
				callback
			) {
				//  if there are any errors, set integration status to disabled AND the radio button group disabled
				var configurationRow = $(
					"[data-tabname=" + tabName + "]",
					$("table.xero-overview")
				);
				var statusIndicator = $(
					".dashboard-status-indicator",
					configurationRow
				);
                var $tab = $("#Tab" + configurationRow.data("tabname"));

                if (validatedSuccessfully === dataValidState.Valid) {
                    configurationRow
                        .addClass("validation-succeeds")
						.removeClass("validation-errors status-warning");
                    statusIndicator
                       .addClass("glyphicon glyphicon-ok text-success")
						.removeClass("glyphicon-minus-sign glyphicon-refresh text-warning status-warning rex-warning-glyphicon");

                    if (backOffice.options.allTabsReportedTheirStatus) {
                        $tab.rexTabNotification({ destroy: true });
                    }
                } else if (validatedSuccessfully === dataValidState.AllowRetry) {
                    configurationRow
                        .addClass("validation-succeeds")
						.removeClass("validation-errors status-warning");
                    statusIndicator
                        .addClass("glyphicon glyphicon-refresh text-success")
						.removeClass("glyphicon-minus-sign glyphicon-ok text-warning rex-warning-glyphicon");
                    $(".success", configurationRow).html(
                        '<span class="retry text-default">This data may not be complete. <a class="tab-anchor" href="#" onclick="BackOffice.ToggleLoader(true); reloadConfigurationFrame(); return false;"> Click here to retry.</a></span>'
					);
				} else if (validatedSuccessfully === dataValidState.Warning) {
					configurationRow
						.addClass("validation-succeeds status-warning")
						.removeClass("validation-errors");
					statusIndicator
						.addClass("glyphicon glyphicon-minus-sign text-success rex-warning-glyphicon text-warning status-warning")
						.removeClass("glyphicon-ok");
				} else {
					if (tabName === "Stores") {
						if (errorType == StoresError.NoStoresSelected) {
							$(".error", configurationRow).html(
								'<span class="error">You must select at least one store to be a part of this integration. <a class="tab-anchor hidden" href="#">Click here to fix.</a></span>'
							);
						} else {
							$(".error", configurationRow).html(
								'<span class="error">There is an issue with your store mappings. <a class="tab-anchor hidden" href="#">Click here to fix.</a></span>'
							);
						}
						configurationRow
							.addClass("validation-errors")
							.removeClass("validation-succeeds status-warning");
						statusIndicator
							.addClass("glyphicon glyphicon-minus-sign text-warning")
							.removeClass("glyphicon-ok text-success rex-warning-glyphicon");
					} else {
						configurationRow
							.addClass("validation-errors")
							.removeClass("validation-succeeds status-warning");
						statusIndicator
							.addClass("glyphicon glyphicon-minus-sign text-warning")
							.removeClass("glyphicon-ok text-success rex-warning-glyphicon");
					}

					if (clearText) {
						// We probably aren't connected so clear out the text from the individual tabs
						var errorSpan = $(".error", configurationRow);
						errorSpan.html("N/A");
					}

					if (backOffice.options.allTabsReportedTheirStatus) {
						$tab.rexTabNotification();
					}
				}

				if (typeof callback == "function") {
					callback();
				}
				statusIndicator.rexElementSpinner({ destroy: true });
			},
			notificationEmailIsValid = function(elementSelector) {
				var $el = $(elementSelector);
				return BackOffice.IsEmailValid($el);
			},
			handleAllDataIsValid = function(isAllDataValid, allTabsHaveReported) {
				var $rbnEnable = $("#rbnEnabled", scopeSelector);
				var $rbnDisable = $("#rbnDisabled", scopeSelector);
				var $tableCell = $rbnEnable.closest("td");

				if (
					$("tr.validation-errors", scopeSelector).length == 0 &&
					allTabsHaveReported
				) {
					$rbnEnable.prop("disabled", false);
					$rbnEnable.closest("span").prop("disabled", false);
					$rbnDisable.prop("disabled", false);
					$rbnDisable.closest("span").prop("disabled", false);
					$tableCell.removeAttr("title");

					$rbnDisable.prop("checked", false);
					$rbnEnable.prop("checked", false);
					var $selectedElement = getCachedStatusSelection();
					$selectedElement.prop("checked", true);
				} else {
					var disableControlTooltip =
						"Status cannot be enabled while configuration is not valid.";
					disableSatusControl($rbnEnable, $rbnDisable, $tableCell, disableControlTooltip);

					if (!isAllDataValid || allTabsHaveReported) {
						$rbnDisable.prop("checked", true);
					}
				}
				setDisabledIntegrationByAdmin(integrationData.is_disabled_by_admin, isCurrentUserGod);
			},
			cacheStatusSelection = function() {
				var $rbnEnable = $("#rbnEnabled", scopeSelector);
				var $rbnDisable = $("#rbnDisabled", scopeSelector);

				if ($rbnDisable.prop("checked")) {
					$rbnDisable.data("original-selection", true);
					$rbnEnable.removeData("original-selection");
				} else if ($rbnEnable.prop("checked")) {
					$rbnEnable.data("original-selection", true);
					$rbnDisable.removeData("original-selection");
				}
			},
			getCachedStatusSelection = function() {
				var $rbnEnable = $("#rbnEnabled", scopeSelector);
				var $rbnDisable = $("#rbnDisabled", scopeSelector);

				if ($rbnEnable.data("original-selection") !== undefined) {
					return $rbnEnable;
				}

				return $rbnDisable;
			},
			getIntegrationData = function() {
				return backOffice.options.integrationData;
			},
			setIntegrationData = function(integrationData) {
				backOffice.options.integrationData = integrationData; //   re-cache
				$("#hdnIntegration").val(JSON.stringify(integrationData));
			},
			// Sets the enabled/disabled radio buttons
			setIntegrationEnabled = function(isEnabled) {
				var formData = getIntegrationData();
				formData.is_enabled = isEnabled.toString();
				setIntegrationData(formData);
				$("#rbnEnabled").prop("checked", isEnabled);
				$("#rbnDisabled").prop("checked", !isEnabled);
			},
			setDisabledIntegrationByAdmin = function (isDisabledByAdmin, isCurrentUserGod) {
				if (isDisabledByAdmin && !isCurrentUserGod) {
				var $rbnEnable = $("#rbnEnabled", scopeSelector);
				var $rbnDisable = $("#rbnDisabled", scopeSelector);
				var disableControlTooltip =
					"Retail Express Support staff are investigating this integration, it cannot be enabled at this time.";
				var $tableCell = $rbnEnable.closest("td");

				disableSatusControl($rbnEnable, $rbnDisable, $tableCell, disableControlTooltip);
				}

				if (isDisabledByAdmin)
					$("#txtAdminDisabled", scopeSelector).html("By Retail Express Admin");
			},
			getSettingsdata = function() {
				return backOffice.options.settingsData;
			},
			disableSatusControl = function ($rbnEnable, $rbnDisable, $tableCell, disableControlTooltip) {
				$rbnEnable.prop("disabled", true);
				$rbnEnable.closest("span").prop("disabled", true);
				$rbnDisable.prop("disabled", true);
				$rbnDisable.closest("span").prop("disabled", true);
				$tableCell.prop("title", disableControlTooltip);
			};

		return $.extend(backOffice.Integration.IntegrationDetails, {
			Init: initialise,
			HandleAllDataIsValid: handleAllDataIsValid,
			CacheStatusSelection: cacheStatusSelection,
			NotificationEmailIsValid: notificationEmailIsValid,
			UpdateTabStatusIndicators: updateTabStatusIndicators,
			SetIntegrationEnabled: setIntegrationEnabled,
			GetIntegrationData: getIntegrationData,
			SetCachedIntegrationData: setIntegrationData,
            GetSettingsData: getSettingsdata,
            DataValidState: dataValidState,
			DetermineErrorOrRetry: determineErrorOrRetry,
			SetDisabledIntegrationByAdmin: setDisabledIntegrationByAdmin

		});
	})();

	return backOffice.Integration.IntegrationDetails;
})(BackOffice || {}, jQuery);

//  XeroConnect.aspx
var AccountingConnect = (function(backOffice, $) {

    backOffice.Integration.AccountingConnect = (function() {
		var scopeSelector = backOffice.options.scopeSelector;

		var initialise = function(options) {
				$.extend(backOffice.options, options);
				events();
			},
			events = function() {
				$("#btnAuthAccountIntegration", scopeSelector).click(function(e) {
					BackOffice.ToggleLoader(true);
					e.preventDefault();
					initiateOauthHandshake();
				});
			},
			initiateOauthHandshake = function(accountingPackage, integrationId) {
				BackOffice.ToggleLoader(true);

				var url = "/Dotnet/admin/api/accounting/initiateOauthHandshake/"+accountingPackage;

				if (typeof integrationId !== "undefined") {
					url += "/" + integrationId;
				}

				$.get(url)
					.done(function(response) {
						if (response.status === "Success") {
							//is this using hte new 
							if( typeof response.data !== "undefined" && typeof response.data.loginUri !== "undefined" ) {
								//and redirect the page to the loginuri
								window.top.location.href = response.data.loginUri;
							}else{
								// Pre-request was successful, so redirect to the url given
								window.top.location.href = response.data;
							}
						} else {
							BackOffice.DisplayErrorMessage("Error - " + response.d.data);
							BackOffice.ToggleLoader(true);
						}
					})
					.fail(function(data) {
						BackOffice.DisplayErrorMessage("Error - " + data);
						BackOffice.ToggleLoader(true);
					});
			};

		return $.extend(backOffice.Integration.AccountingConnect, {
			Init: initialise,
			InitiateOauthHandshake: initiateOauthHandshake
		});
	})();

	return backOffice.Integration.AccountingConnect;
})(BackOffice || {}, jQuery);
